export const animation = {
  BAR_COEF: 100,
  BAR_FULL_FIRST_COEF: 1000,
  TIMEOUT_SLIDE_ANIMATION_HEADER: 700,
};
